// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoProcessor_video__24_uV","videoBuffer":"VideoProcessor_videoBuffer__3Fhm_","videoOutput":"VideoProcessor_videoOutput__1Bd0U"};